// extracted by mini-css-extract-plugin
module.exports = {"chatReply":"chatReply_chatReply__o86yd","replyContent":"chatReply_replyContent__GOvXZ","img":"chatReply_img__jUsiT"};